module.exports = __webpack_public_path__ + "img/unpay.4d4cbbaf.png";